/**
 * Merges multiple refs into one. Works with either callback or object refs.
 */ export function mergeRefs(...refs) {
    if (refs.length === 1) {
        return refs[0];
    }
    // @ts-expect-error - 'T' could be instantiated with an arbitrary type which could be unrelated to 'T | null'
    return (value)=>{
        // eslint-disable-next-line no-restricted-syntax
        for (const ref of refs){
            if (typeof ref === 'function') {
                ref(value);
            } else if (ref != null) {
                ref.current = value;
            }
        }
    };
}

//# sourceMappingURL=mergeRefs.js.map